import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import { IntangibleService } from './Service/intangible.service';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-intangible',
  templateUrl: './intangible.component.html',
  styleUrls: ['./intangible.component.scss']
})
export class IntangibleComponent implements OnInit{


  CreateIntangibleFormGroup: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;

  constructor(public FormBuilder: FormBuilder, public IntangibleService: IntangibleService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }


  ngOnInit(): void {
    debugger;
    this.commonService.getNotesData();
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.CreateIntangibleForm();
      this.getIntangible();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.CreateIntangibleFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.getIntangible_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.CreateIntangibleFormGroup.disable()

  }

  CreateIntangibleForm() {
    this.CreateIntangibleFormGroup = this.FormBuilder.group({
      IntangibleFixedAssetsId:new FormControl(),
      IntangibleAssetsGrossCost_Start:new FormControl(),
      TotalAdditionsIncludingFromBusinessCombinationsIntangibleAssets:new FormControl(),
      DisposalsIntangibleAssets:new FormControl(),
      IntangibleAssetsGrossCost_End: new FormControl({ value: '', disabled: true }),
      AccumulatedAmortisationImpairmentIntangibleAssets_Start:new FormControl(),
      IncreaseFromAmortisationChargeForYearIntangibleAssets:new FormControl(),
      DisposalsDecreaseInAmortisationImpairmentIntangibleAssets:new FormControl(),
      AccumulatedAmortisationImpairmentIntangibleAssets_End: new FormControl({ value: '', disabled: true }),
      IntangibleAssets_End: new FormControl({ value: '', disabled: true }),
      IntangibleAssets_Start:new FormControl(),
      IntangibleAssetsFreeøtextComment:new FormControl(),
      MatchingData:new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate:new FormControl(),
      ModifiedBy:new FormControl(),
      ModifiedDate:new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        debugger;
        var MatchingData = this.CreateIntangibleFormGroup.controls['MatchingData'].value;
        this.CreateIntangibleFormGroup.reset();
        this.CreateIntangibleFormGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.CreateIntangibleFormGroup.controls['APPeriodId'].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  getIntangible() {
    debugger; 
    this.IntangibleService.GetOneIntangible(this.CreateIntangibleFormGroup.controls['APPeriodId'].value).subscribe(data => {
      this.CreateIntangibleFormGroup.patchValue(data);
      this.CreateIntangibleFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }
  getIntangible_LY() {
    debugger; 
    this.IntangibleService.GetOneIntangible_LY(this.CreateIntangibleFormGroup.controls['APPeriodId'].value).subscribe(data => {
      this.showBubbledata = data;
      this.CreateIntangibleFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  Calculations() {
    debugger;
    var total1 = (+this.CreateIntangibleFormGroup.controls['IntangibleAssetsGrossCost_Start'].value + +this.CreateIntangibleFormGroup.controls['TotalAdditionsIncludingFromBusinessCombinationsIntangibleAssets'].value) - +this.CreateIntangibleFormGroup.controls['DisposalsIntangibleAssets'].value;
    var total2 = (+this.CreateIntangibleFormGroup.controls['AccumulatedAmortisationImpairmentIntangibleAssets_Start'].value + +this.CreateIntangibleFormGroup.controls['IncreaseFromAmortisationChargeForYearIntangibleAssets'].value) - +this.CreateIntangibleFormGroup.controls['DisposalsDecreaseInAmortisationImpairmentIntangibleAssets'].value;
  
    this.CreateIntangibleFormGroup.controls['IntangibleAssetsGrossCost_End'].setValue(total1 == 0 ? '' : total1);
    this.CreateIntangibleFormGroup.controls['AccumulatedAmortisationImpairmentIntangibleAssets_End'].setValue(total2 == 0 ? '' : total2);

    var total3 = +this.CreateIntangibleFormGroup.controls['IntangibleAssetsGrossCost_End'].value - +this.CreateIntangibleFormGroup.controls['AccumulatedAmortisationImpairmentIntangibleAssets_End'].value;
    this.CreateIntangibleFormGroup.controls['IntangibleAssets_End'].setValue(total3 == 0 ? '' : total3);

  }

  On_Next() {  // Working
    debugger;
 //   this.Router.navigate(['/taxation']);
    if (this.On_NextBalancesheatValidaton()) {
      this.IntangibleService.SaveIntangible(this.CreateIntangibleFormGroup.getRawValue()).subscribe(data => {
        debugger;
        this.CreateIntangibleFormGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Intangible fixed assets", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'intangiblefixedassets') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.CreateIntangibleFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Intangible fixed assets", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }


  On_NextBalancesheatValidaton() {
    debugger;
    if (this.commonService.showControl == true ) {
      if (+this.CreateIntangibleFormGroup.controls['IntangibleAssets_End'].value != this.CreateIntangibleFormGroup.controls['MatchingData'].value.Item1) {
        if(this.commonService.AccountTypeId != 2 )
        Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.EndDate + " must tally with the Intangible Fixed Assets field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".","warning")
        else
          Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.EndDate + " must tally with the Intangible Fixed Assets field value in the Trial balance for the year " + this.commonService.StartYear + ".", "warning")

        //Swal.fire({
        //  text: "'Net book value' at " + this.commonService.StartDate + " must tally with the 'Intangible Fixed Assets' field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      //else
      //  return true
      else if (+this.CreateIntangibleFormGroup.controls['IntangibleAssets_Start'].value != this.CreateIntangibleFormGroup.controls['MatchingData'].value.Item2) {
        debugger  
        if (this.commonService.AccountTypeId !=  2)
          Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.LastyearEndDate + " must tally with the Intangible Fixed Assets field value in the Statement of Financial Position for the year " + this.commonService.LastYear + ".", "warning")
        else
          Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.LastyearEndDate + " must tally with the Intangible Fixed Assets field value in the  Trial balance for the year " + this.commonService.LastYear + ".", "warning")

        //Swal.fire({
        //  text: "'Net book value' at " + this.commonService.EndDate + " must tally with the 'Intangible Fixed Assets' field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      else
        return true
      // return true
    }
    else {
      if (+this.CreateIntangibleFormGroup.controls['IntangibleAssets_End'].value != this.CreateIntangibleFormGroup.controls['MatchingData'].value.Item1) {
        if (this.commonService.AccountTypeId != 2)
        Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.EndDate + " must tally with the Intangible Fixed Assets field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".", "warning")
        else
        Swal.fire("Andica Accounts Production", "Net book value at " + this.commonService.EndDate + " must tally with the Intangible Fixed Assets field value in the Trial Balance for the year " + this.commonService.StartYear + ".", "warning")

        //Swal.fire({
        //  text: "'Net book value' at " + this.commonService.StartDate + " must tally with the 'Intangible Fixed Assets' field value in the Statement of Financial Position for the year " + this.commonService.StartYear +".",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      else
        return true
      // return true
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreateIntangibleFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }
}
